








/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../helpers";
// PublishPost
// PUBLISHPOST
const GETALLSTATESBYCOUNTRY= createAsyncThunk(
  "getAllStatesByCountry/getAllStatesByCountry",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllStatesByCountrySlice = createSlice({
  name: "getAllStatesByCountrySlice",
  initialState: {
    getAllStatesByCountry: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllStatesByCountry: (state) => {
        state.getAllStatesByCountry.loading = false
        state.getAllStatesByCountry.error = false
        state.getAllStatesByCountry.data = []
        state.getAllStatesByCountry.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLSTATESBYCOUNTRY.fulfilled, (state, action) => {
      state.getAllStatesByCountry = {
        ...state.getAllStatesByCountry,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLSTATESBYCOUNTRY.pending, (state, action) => {
      state.getAllStatesByCountry = {
        ...state.getAllStatesByCountry,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLSTATESBYCOUNTRY.rejected, (state, action) => {
      state.getAllStatesByCountry = {
        ...state.getAllStatesByCountry,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllStatesByCountryAction = {
    GETALLSTATESBYCOUNTRY,
};

export { getAllStatesByCountryAction };
export default getAllStatesByCountrySlice.reducer;
export const {setInitialStateOfgetAllStatesByCountry} = getAllStatesByCountrySlice.actions
